<template>
  <div>
    <button class="btn btn-primary btn-sm"
        data-toggle="tooltip" 
        data-placement="top" 
        title="New"
        @click="fnShowModal()">New
    </button>

    <b-modal ref="modal" hide-footer title="Faq - new">
        <div class="d-block">
        <form v-on:submit.prevent="createNew">
            <div class="form-group">
                <label for="title">Question</label>
                <textarea type="text" 
                rows="3"
                class="form-control type2" 
                id="title" 
                placeholder="Question"
                v-model="title"></textarea>
                <div class="invalid-feedback" v-if="errors.title">{{ errors.title[0] }}</div>
            </div>
            <div class="form-group">
                <label for="description">Answer</label>
                <vue-editor v-model="description" :editor-toolbar="customToolbar" />
                <div class="invalid-feedback" v-if="errors.description">{{ errors.description[0] }}</div>
            </div>
            <hr>
            <div class="text-right">
                <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
                <button type="submit" class="btn btn-primary btn-sm">Save</button>
            </div>
        </form>
        </div>
    </b-modal>
  </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as faqService from '../../services/faq.service';
    export default {
        name:"ModalFaqNew",
        components: {
            
        },
        data(){
            return{
                errors:{},
                title:'',
                description:'',
                customToolbar: [
                    [{ font: [] }],
                    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                    [
                        { align: "" },
                        { align: "center" },
                        { align: "right" },
                        { align: "justify" }
                    ],
                    ["blockquote", "code-block"],
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                ]
            }
        },
        methods:{
            ...mapActions([
                'fetchFaqAll'
            ]),
            fnShowModal(){
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            createNew:async function(){
                let formData = new FormData();
                formData.append('title', this.title);
                formData.append('description', this.description);
            try{
                const response = await faqService.add(formData);

                this.hideModal();
                this.fetchFaqAll()

                messageService.fnSweetAlertSuccessToast('Faq - new', 'added successfully');

                this.name = '';

                }catch(error){
                    switch (error.response.status){
                    case 422:
                        this.errors = error.response.data.errors;
                        break;

                    case 500:
                        messageService.fnSweetAlertErrorToast('Faq - new', error.response.data.message);
                        break;

                    default:
                            messageService.fnSweetAlertErrorToast('Faq - new', 'Something wrong');
                        break;
                    }
                }
            },
        }
    }
</script>